import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';

/**
 * Custom hook for managing customer photos filter actions
 * @param {Object} filterState - Current filter state
 * @param {Object} filterActions - Filter action functions
 * @returns {Object} Customer photos filter action functions
 */
const useCustomerPhotosFilterActions = (filterState, filterActions) => {
  const $ = _c(12);
  const {
    materialFilter,
    roomFilter
  } = filterState;
  const {
    setMaterialFilter,
    setRoomFilter,
    toggleColorFilter
  } = filterActions;
  let t0;
  if ($[0] !== materialFilter || $[1] !== setMaterialFilter) {
    t0 = value => {
      const newValue = materialFilter === value ? "" : value;
      setMaterialFilter(newValue);
    };
    $[0] = materialFilter;
    $[1] = setMaterialFilter;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== roomFilter || $[4] !== setRoomFilter) {
    t1 = value_0 => {
      const newValue_0 = roomFilter === value_0 ? "" : value_0;
      setRoomFilter(newValue_0);
    };
    $[3] = roomFilter;
    $[4] = setRoomFilter;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== toggleColorFilter) {
    t2 = color => {
      toggleColorFilter(color);
    };
    $[6] = toggleColorFilter;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t3 = {
      setMaterialFilter: t0,
      setRoomFilter: t1,
      toggleColorFilter: t2
    };
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const customerPhotosFilterActions = t3;
  return customerPhotosFilterActions;
};
export default useCustomerPhotosFilterActions;